import browserUtils from './browserUtils';
import { FUNNEL } from '../constants/serviceConstant';
import { INDIA_WEBSITE_VALUE, AFFILIATES, AFFILIATE_CONFIG } from '../constants/appConstant';
import { CACHE_TTL_MS, getDataFromCache, setDataInCache } from '../../cache';
import { getCookie } from '../service/cookieService';

const getMMT_HLD_OBJ = () => (ssr.isOnClient ? window.MMT_HLD : ssr.MMT_HLD);

const checkIfAffiliateIsValid = () => {
  const aff = getAffiliateDetails().affiliateIdentifier;
  const MMT_HLD = getMMT_HLD_OBJ();
  MMT_HLD.aff = aff;
  return MMT_HLD && MMT_HLD.aff !== '' && (MMT_HLD.aff === 'GI' || MMT_HLD.aff === 'TP');
};

const isOtherFunnel = () => {
  const funnel = getFunnel();
  return funnel === FUNNEL ? false : funnel;
};

const getFunnel = () => {
  let funnel = FUNNEL;
  const urlParamsMap = browserUtils.getUrlParamsMap();
  if (urlParamsMap.pt) {
    funnel = urlParamsMap.pt;
    setDataInCache('funnel', funnel, CACHE_TTL_MS.FUNNEL);
    return funnel;
  }
  return getDataFromCache('funnel') || funnel;
};

const isIndiaWebsite = () => {
  const MMT_HLD = getMMT_HLD_OBJ();
  if (MMT_HLD.website === undefined) {
    const website = getCookie('ccde');
    MMT_HLD.website = website;
  }
  return MMT_HLD.website === INDIA_WEBSITE_VALUE;
};

const getWebsiteValue = () => {
  const MMT_HLD = getMMT_HLD_OBJ();
  return MMT_HLD.website ? MMT_HLD.website : INDIA_WEBSITE_VALUE;
};

const getMarketingChannel = () => {
  const urlParamsMap = browserUtils.getUrlParamsMap();
  let marketingChannel = '';
  if (urlParamsMap.cmp) {
    marketingChannel = urlParamsMap.cmp;
  } else if (urlParamsMap.intid) {
    marketingChannel = urlParamsMap.intid;
  } else if (MMT_HLD.fromSEO) {
    marketingChannel = 'SEO';
  }
  return marketingChannel;
};
export const getMonthNames = () => [
  { value: '01', label: 'Jan' },
  { value: '02', label: 'Feb' },
  { value: '03', label: 'Mar' },
  { value: '04', label: 'Apr' },
  { value: '05', label: 'May' },
  { value: '06', label: 'Jun' },
  { value: '07', label: 'Jul' },
  { value: '08', label: 'Aug' },
  { value: '09', label: 'Sep' },
  { value: '10', label: 'Oct' },
  { value: '11', label: 'Nov' },
  { value: '12', label: 'Dec' },
];

const formatNumber = n => (n < 10 ? `0${n}` : n);

export const getDates = () => {
  const startDate = 1;
  const endDate = 31;

  const dates = [];

  for (let i = startDate; i <= endDate; i++) {
    dates.push({ value: i < 10 ? `0${i}` : i, label: i });
  }
  return dates;
};

export const getYears = valueRange => {
  const { end, start } = valueRange ?? {};
  let startYear = 1920;
  let endYear = 2039;
  if (end && start) {
    startYear = start.split('/')[2];
    endYear = end.split('/')[2];
  }
  const yearsToShow = [];
  for (let i = endYear; i >= startYear; i--) {
    yearsToShow.push({ value: i, label: i });
  }

  return yearsToShow;
};

const getStrToDateObj = (dateStr, type) => {
  let dateObj;
  let year;
  let month;
  let date;
  switch (type) {
    case 'YYYY-MM-DD':
      [year, month, date] = dateStr.split('-');
      dateObj = new Date(Number(year), Number(month) - 1, Number(date));
      break;

    default:
      [year, month, date] = dateStr.split('-');
      dateObj = new Date(Number(year), Number(month) - 1, Number(date));
      break;
  }

  return dateObj;
};

const increamentDays = (date, count) => {
  const copyDate = new Date(date);
  copyDate.setDate(date.getDate() + count);
  return copyDate;
};

const getMonth = month => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  return months[month - 1];
};
const getDayCount = (startDateObj, endDateObj) => (endDateObj - startDateObj) / (3600 * 24 * 1000);

const getServerIP = () => getMMT_HLD_OBJ().serverIp;

const getClientIP = () => {
  const MMT_HLD = getMMT_HLD_OBJ();
  if (MMT_HLD.clientIp) {
    return MMT_HLD.clientIp;
  }
  const holInfoValue = getCookie('hol-info');
  if (holInfoValue) {
    MMT_HLD.clientIp = holInfoValue.split('-')[1];
  }
  return MMT_HLD.clientIp;
};

const getIPCityName = () => getMMT_HLD_OBJ().ipCityName;

const getCompanyCode = () => (ssr.isOnClient ? window.cmpCode : ssr.cmpCode);
const getJSESSIONID = () => getMMT_HLD_OBJ().jSessionId;

const getEnvironment = () => (ssr.isOnClient ? window.environment : ssr.environment);

const getUniqueIdentifier = () => {
  const dtStr = new Date().getTime();
  return `${dtStr}_${Math.floor(Math.random() * 1000000)}`;
};

/**
 * @description
 * returns value of affiliate from url params
 * [use getAffiliateDetails instead]
 *
 * @returns {string} - Affiliate
 */
const getAffiliate = () => {
  let affiliate = AFFILIATES.MMT;
  const hostName = ssr.isOnClient ? window?.location?.hostname : '';
  const queryParamsMap = browserUtils.getUrlParamsMapV2();

  if (queryParamsMap.affiliate || queryParamsMap.aff) {
    affiliate = queryParamsMap.affiliate || queryParamsMap.aff;
  } else if (hostName) {
    if (AFFILIATE_CONFIG[AFFILIATES.GOIBIBO].baseUrl.indexOf(hostName) !== -1) {
      affiliate = AFFILIATES.GOIBIBO;
    } else if (AFFILIATE_CONFIG[AFFILIATES.INDIGO].baseUrl.indexOf(hostName) !== -1) {
      affiliate = AFFILIATES.INDIGO;
    } else if (AFFILIATE_CONFIG[AFFILIATES.HDFC_SB].baseUrl.indexOf(hostName) !== -1) {
      affiliate = AFFILIATES.HDFC_SB;
    } else if (AFFILIATE_CONFIG[AFFILIATES.AIX].baseUrl.indexOf(hostName) !== -1) {
      affiliate = AFFILIATES.AIX;
    } else if (AFFILIATE_CONFIG[AFFILIATES.HE_AGENT].baseUrl.indexOf(hostName) !== -1) {
      affiliate = AFFILIATES.MMT;
    }
  }
  return affiliate;
};

const getAffiliateNew = () => {
  let affiliate = AFFILIATES.MMT;
  const hostName = ssr.isOnClient ? window?.location?.hostname : '';
  const queryParamsMap = browserUtils.getUrlParamsMapV2();

  if (hostName) {
    if (AFFILIATE_CONFIG[AFFILIATES.GOIBIBO].baseUrl.indexOf(hostName) !== -1) {
      affiliate = AFFILIATES.GOIBIBO;
    } else if (AFFILIATE_CONFIG[AFFILIATES.INDIGO].baseUrl.indexOf(hostName) !== -1) {
      affiliate = AFFILIATES.INDIGO;
    } else if (AFFILIATE_CONFIG[AFFILIATES.HDFC_SB].baseUrl.indexOf(hostName) !== -1) {
      affiliate = AFFILIATES.HDFC_SB;
    } else if (AFFILIATE_CONFIG[AFFILIATES.AIX].baseUrl.indexOf(hostName) !== -1) {
      affiliate = AFFILIATES.AIX;
    } else if (AFFILIATE_CONFIG[AFFILIATES.HE_AGENT].baseUrl.indexOf(hostName) !== -1) {
      affiliate = AFFILIATES.HE_AGENT;
    } else if (queryParamsMap.affiliate || queryParamsMap.aff) {
      affiliate = queryParamsMap.affiliate || queryParamsMap.aff;
    }
  } else if (queryParamsMap.affiliate || queryParamsMap.aff) {
    affiliate = queryParamsMap.affiliate || queryParamsMap.aff;
  }
  return affiliate;
};
/**
 *
 * @typedef {Object} affiliateConfig
 * @property {string} affiliateIdentifier - affiliate identifier(value that comes in the ulr params),
 * @property {string} assetUrl - asset urls of the current affiliate,
 * @property {string} apiUrl - base api url for current affiliate,
 * @property {string} baseUrl - base url of the app,
 * @property {string} affiliateName - name of the affiliate(can be used to display on view),
 *
 */

/**
 * @description
 * returns an object containing details related to current affiliate
 *
 * @returns {affiliateConfig}
 *
 */
const getAffiliateDetails = () => {
  const affiliateIdentifier = getAffiliateNew();
  if (AFFILIATE_CONFIG[affiliateIdentifier]) {
    return AFFILIATE_CONFIG[affiliateIdentifier];
  }
  const affDetails = AFFILIATE_CONFIG[AFFILIATES.MMT];
  affDetails.affiliateIdentifier = affiliateIdentifier;
  return affDetails;
};

const isNonMmtAffiliate = () => {
  const affiliateIdentifier = getAffiliate();
  if (affiliateIdentifier === AFFILIATES.MMT) {
    return false;
  }
  return true;
};

const isMmtDomain = () => {
  const hostName = ssr.isOnClient ? window?.location?.hostname : '';
  if (AFFILIATE_CONFIG[AFFILIATES.MMT].baseUrl.indexOf(hostName) === -1) {
    return false;
  }
  return true;
};

const isHEMmtDomain = () => {
  const hostName = ssr.isOnClient ? window?.location?.hostname : '';

  if (!hostName || AFFILIATE_CONFIG[AFFILIATES.HE_AGENT].baseUrl.indexOf(hostName) === -1) {
    return false;
  }
  return true;
};

/**
 * @description
 * returns auth cookie key
 */
const getAuthCookieKey = () => {
  let affiliateDetails = getAffiliateDetails();
  const hostName = ssr.isOnClient ? window?.location?.hostname : '';
  if (hostName && AFFILIATE_CONFIG[AFFILIATES.HE_AGENT].baseUrl.indexOf(hostName) !== -1) {
    affiliateDetails = AFFILIATE_CONFIG[AFFILIATES.HE_AGENT];
  }

  const { authCookieKey } = affiliateDetails;
  if (!isMmtDomain() && authCookieKey) {
    return authCookieKey;
  }
  return 'mmt-auth';
};

/**
 * @description
 * returns auth token from cookies
 */
const getAuthToken = () => {
  const authCookieKey = getAuthCookieKey();

  const authToken = getCookie(authCookieKey);
  return authToken;
};

const setContactManagementPopUp = pageName => {
  if (ssr?.isOnClient) {
    const isQueryAlreadyOpened = window.sessionStorage.getItem('isQueryAlreadyOpened');
    const prevValue = JSON.parse(isQueryAlreadyOpened);
    const currentVal = { [pageName]: true };
    sessionStorage.setItem('isQueryAlreadyOpened', JSON.stringify({ ...prevValue, ...currentVal }));
  }
};

if (ssr.isOnClient) {
  window.jSessionId = getUniqueIdentifier();
} else {
  ssr.jSessionId = getUniqueIdentifier();
}
export {
  getDayCount,
  getMonth,
  getStrToDateObj,
  increamentDays,
  checkIfAffiliateIsValid,
  isIndiaWebsite,
  isHEMmtDomain,
  getWebsiteValue,
  getMarketingChannel,
  formatNumber,
  getFunnel,
  isOtherFunnel,
  getServerIP,
  getClientIP,
  getIPCityName,
  getCompanyCode,
  getJSESSIONID,
  getEnvironment,
  getUniqueIdentifier,
  getMMT_HLD_OBJ,
  getAffiliate,
  getAffiliateDetails,
  getAuthToken,
  getAuthCookieKey,
  isNonMmtAffiliate,
  isMmtDomain,
  setContactManagementPopUp,
};
